import React from 'react';

import Text from '~components/atoms/Text';
import TabPageContainer from '~components/atoms/TabPageContainer';
import TabPageHeaderWrapper from '~components/atoms/TabPageHeaderWrapper';

import * as Styles from './_goldConversion.module.scss';
import GoldConversionTable from './GoldConversionTable';
import GoldConversionPaginator from './GoldConversionPaginator';
import GoldConversionSearchAndFilterBar from './GoldConversionSearchAndFilterBar';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import GoldConversionModal from './CreateGoldConversionModal';
import combinedActions from '~redux/combinedActions';
import ActionButton from '~components/atoms/ActionButton';
import { ModuleEnum, PermissionsEnum } from '~utils/enums';

const GoldConversion = () => {
    const dispatch = useAppDispatch();

    const createAccessModules = useAppSelector(state => state.auth.userDetails.access)?.find(access => access.permission === PermissionsEnum.Create)?.modules || [];

    const isOpen = useAppSelector(state => state.gold.modals.isCreateGoldConversionModalOpen);

    const setIsCreateGoldConversionModalOpen = () => dispatch(combinedActions.goldSetIsCreateGoldConversionModalOpen(true));
    const handleOnCloseModal = () => {
        dispatch(combinedActions.goldClearInventoryFilterParams());
        dispatch(combinedActions.customerResetCustomerState());
        dispatch(combinedActions.goldGetAllInventoriesAttempt());
        dispatch(combinedActions.customerResetCustomerInventory());
        dispatch(combinedActions.goldResetGoldConversionAmount());
        dispatch(combinedActions.goldSetIsCreateGoldConversionModalOpen(false));
    };

    return (
        <TabPageContainer>
            <TabPageHeaderWrapper>
                <Text
                    label='Gold Conversion'
                    className={Styles.title}
                    isBold
                />

                {
                    createAccessModules.find(module => module === ModuleEnum.Conversion)
                        &&
                        (
                            <ActionButton
                                label='+ Create New Conversion'
                                onClick={setIsCreateGoldConversionModalOpen}
                            />
                        )
                }
            </TabPageHeaderWrapper>

            <GoldConversionSearchAndFilterBar />
            <GoldConversionTable />
            <GoldConversionPaginator />

            <GoldConversionModal isOpen={isOpen} onClose={handleOnCloseModal} />
        </TabPageContainer>
    );
};

export default GoldConversion;
